import countriesData from '../data/countries.json';

export const formatCountryOptions = () => {
  return countriesData.map(country => ({
    value: country.countryCode,
    label: country.countryName,
    flag: country.countryCode.toLowerCase(),
    dialCode: country.dialCode,
    currency: country.currencyCode,
    capital: country.capital,
    continent: country.continentName
  }));
};

export const formatMobileCodeOptions = () => {
  return countriesData.map(country => ({
    value: country.dialCode,
    label: country.countryName,
    flag:country.countryCode.toLowerCase(),
    dialCode: `+${country.dialCode}`
  }));
};

export const formatCurrencyOptions = () => {
  // Remove duplicate currencies
  const uniqueCurrencies = [...new Set(countriesData.map(country => country.currencyCode))];
  
  return uniqueCurrencies.map(currencyCode => {
    const countryWithCurrency = countriesData.find(country => country.currencyCode === currencyCode);
    return {
      value: currencyCode,
      label: currencyCode,
      symbol: currencyCode,
      flag: countryWithCurrency.countryCode.toLowerCase()
    };
  });
};




